import { Button } from '@piplapps/pipl-ui';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './UploadUsersListContainer.module.less';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const WelcomeModal = (props) => {
  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{gettext('Upload user list')}</div>
      <div className={styles.paragraph}>
        <div className={styles.line}>{gettext('Step 1 - Select and upload the CSV file')}</div>
        <div className={styles.line}>{gettext('Step 2 - Validate the CSV information')}</div>
        <div className={styles.line}>{gettext('Step 3 - Add new users')}</div>
      </div>
      <AnalyticsHandler eventName={AnalyticsEventNames.UPLOAD_USERS_LIST_GET_STARTED}>
        <Button buttonClass="primary-blue" text={gettext('Get started!')} onClick={() => props.clickGetStarted()} />
      </AnalyticsHandler>
    </div>
  );
};

WelcomeModal.propTypes = {
  clickGetStarted: PropTypes.func,
};

export default WelcomeModal;
